import { api } from '../../libs/api'

export default {
  namespaced: true,

  state: {
    detail: {},
  },
  getters: {
    clientUsers: state => state.detail.client_users,
  },
  mutations: {
    detail: (state, detail) => state.detail = detail,
  },
  actions: {
    async fetch ({ commit }) {
      try {
        const client = await api.fetchClient()
        commit('detail', client)
      } catch (e) {
        return Promise.reject(e)
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/client.js